// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideNav_SideDrawer__djmRY","Open":"SideNav_Open__gChDG","Close":"SideNav_Close__kyGv3"};